import { Grid, TextField, Button, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useDialogBetter } from "../../../../hooks/useDialogBetter";
import { SelectBankingForAgreementDialog } from "../SelectBankingForAgreementDialog";

import CancelIcon from "@mui/icons-material/Cancel";


function AgreementBankingFormControl(props) {
  const { t } = useTranslation()

    const { openDialog } = useDialogBetter();

    const handleClick = (e) => {
        openDialog({
        Component: SelectBankingForAgreementDialog,
        componentProps: {
            onSubmit : props.onSelectBanking,
            investmentId: props.investmentId,
            isBankingForWithdrawal: props.isBankingForWithdrawal
        }
        });
    };


  return (
    <Grid container columnSpacing={1} justifyContent={"center"} alignItems={"center"}>
        <Grid item xs={!props.readOnly ? 3 : 4}>
            <TextField
                label={props.isBankingForWithdrawal ? t("bankings.banking_kind_withdrawal") : t("bankings.banking_kind")}
                value={props.banking?.banking_kind || ""}
                disabled
                fullWidth
                InputLabelProps={{shrink: props.banking?.banking_kind}}
            />
            </Grid>
        <Grid item xs={!props.readOnly ? 6 : 8 }>
            <TextField
                label={props.isBankingForWithdrawal ? t("bankings.banking_nr_withdrawal") : t("bankings.banking_nr")}
                value={props.banking?.banking_nr || ""}
                disabled
                fullWidth
                InputLabelProps={{shrink: props.banking?.banking_nr}}
            />
        </Grid>
        {!props.readOnly && (
            <>
                <Grid item xs={1}>
                    {props.banking && <IconButton
                        onClick={(e) => {props.onSelectBanking(null)}}
                    >
                        <CancelIcon color="error" />
                    </IconButton>}
                </Grid>
                <Grid item xs={2}>
                    <Button variant="contained" size="large" fullWidth sx={{"height": "52px"}} onClick={(e)=>handleClick(e)}>
                        {t("search")}
                    </Button>
                </Grid>
            </> 
            )
        }
    </Grid>
  )
}

export default AgreementBankingFormControl